/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'extension.charts.aggregateData': 'Dane zagregowane',
  'extension.charts.aggregateDataDescription':
    'Łączy wartości w jeden punkt danych, jeśli w wielu wierszach występuje taka sama wartość.',
  'extension.charts.category': 'Kategoria',
  'extension.charts.customizeTab': 'Dostosuj',
  'extension.charts.dataMissing.details': 'Nie można znaleźć na stronie tabeli źródłowej tego wykresu.',
  'extension.charts.dataMissing.title': 'Brak danych do wyświetlenia',
  'extension.charts.dataTab': 'Dane',
  'extension.charts.defaultColumnName': 'Kolumna {0}',
  'extension.charts.defaultTitle': 'Wykres bez tytułu',
  'extension.charts.defaultYLabel': 'Oś bez tytułu',
  'extension.charts.extensionTitle': 'Wykres',
  'extension.charts.height': 'Wysokość pola wykresu',
  'extension.charts.height.large': 'Wyższy',
  'extension.charts.height.medium': 'Domyślnie',
  'extension.charts.height.small': 'Niższy',
  'extension.charts.horizontal.orientation.label': 'Poziomy',
  'extension.charts.insert.tooltip': 'Wstaw wykres',
  'extension.charts.legend': 'Legenda',
  'extension.charts.legend.auto': 'Automatycznie',
  'extension.charts.legend.bottom': 'U dołu',
  'extension.charts.legend.left': 'Z lewej',
  'extension.charts.legend.position': 'Położenie legendy',
  'extension.charts.legend.right': 'Z prawej',
  'extension.charts.legend.show': 'Pokaż legendę',
  'extension.charts.legend.top': 'U góry',
  'extension.charts.options.label': 'Opcje wykresu',
  'extension.charts.options.tooltip': 'Zmień opcje wykresu',
  'extension.charts.orientation.label': 'Orientacja',
  'extension.charts.seriesNames': 'Serie danych',
  'extension.charts.showPoints': 'Pokaż punkty danych',
  'extension.charts.smoothLines': 'Wygładź linie',
  'extension.charts.style': 'Styl',
  'extension.charts.title': 'Tytuł',
  'extension.charts.type.bar': 'Słupek',
  'extension.charts.type.fieldDescription': 'Typ wykresu',
  'extension.charts.type.line': 'Liniowy',
  'extension.charts.type.pie': 'Kołowy',
  'extension.charts.userTitle': 'Tytuł',
  'extension.charts.vertical.orientation.label': 'Pionowy',
  'extension.charts.xAxis': 'Oś X',
  'extension.charts.xLabel': 'Etykieta osi X',
  'extension.charts.yLabel': 'Etykieta osi Y',
};
